import api from "./api";

export const fetchLanguagesFromAPI = async () => {
  try {
    const response = await api.get("/polyglot/languages");

    // Validate response status
    if (response.status !== 200) {
      throw new Error(
        `Failed to fetch languages: ${response.status} ${response.statusText}`
      );
    }

    // Validate response data
    if (!response.data || !Array.isArray(response.data)) {
      throw new Error(
        "Invalid response format: Expected an array of languages"
      );
    }

    return response.data;
  } catch (error) {
    console.error("fetchLanguagesFromAPI Error:", error.message);
    throw error; // Re-throw for saga to handle
  }
};
